import React from "react"
import { Box } from "@mui/material"
import { Heading, ViraText } from "../atoms/ViraText"

export type ProgressNoteFieldRowProps = {
  heading: string
  body: string
}

export function ProgressNoteFieldRow({
  heading,
  body,
}: ProgressNoteFieldRowProps) {
  return (
    <Box>
      <Heading level="label" sx={{ mb: 1, letterSpacing: "1.4px", fontSize: 11 }}>
        {heading}
      </Heading>
      <ViraText tone="ink" sx={{ fontSize: 15, lineHeight: 1.65 }}>
        {body}
      </ViraText>
    </Box>
  )
}
